import { auth } from "./auth";

export const AuthProvider = auth.AuthProvider;
// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = auth.useAuth;
